export default {
    en: {
        pageTitle: "Using separate components",
        genderGroupTitle: "Gender group",
        dateGroupTitle: "Date group",
        advanceFilterTitle: "Advanced filter",
        doctorCardTitle: "Doctor card",
        dateSliderTitle: "Date range slider",
    },
    es: {
        pageTitle: "Usando componentes separados",
        genderGroupTitle: "Selector de género",
        dateGroupTitle: "Selector de fecha",
        advanceFilterTitle: "Filtro avanzado",
        doctorCardTitle: "Tarjeta de doctor",
        dateSliderTitle: "Deslizador de rango de fecha",
    },
    ko: {
        pageTitle: "Lè l sèvi avèk konpozan separe",
        genderGroupTitle: "Chwazi de moun",
        dateGroupTitle: "Kalite sele",
        advanceFilterTitle: "Avanse filtre",
        doctorCardTitle: "Doktè kat",
        dateSliderTitle: "Date seri kurseur",
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/components/components.language.js
// module id = 625
// module chunks = 0